export default __webpack_public_path__ + "src/images/packages/villa-mangata/66ff783966d44003a4b01b6710138699-3.jpg";